import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from './ui/dialog';
import { Button } from './ui/button';
import { locations } from '../data/mockData';

const CitySelectionModal = ({ isOpen, onClose, onSelectCity, context = 'booking' }) => {
  const handleCitySelect = (city) => {
    const location = locations.find(loc => loc.city === city);
    if (location) {
      let message = '';
      const HEART = '\u{1F9E1}'; // 🧡 orange heart — explicit codepoint to avoid source encoding issues

      if (context === 'booking') {
        message = `Hola Morea! Como estan? ${HEART}, quiero agendar una cita en la sede de ${city}. Me gustaria recibir mas informacion`;
      } else if (context.startsWith('dress-')) {
        const dressName = context.replace('dress-', '');
        message = `Hola Morea, quiero consultar disponibilidad del vestido ${dressName} en la sede de ${city}.`;
      }

      const phone = String(location.whatsapp).replace(/[^\d]/g, ''); // wa.me requires digits only
      const whatsappUrl = `https://wa.me/${phone}?text=${encodeURIComponent(message)}`;
      window.open(whatsappUrl, '_blank');
      onClose();
    }
  };

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle className="text-2xl font-serif text-neutral-900">Selecciona tu ciudad</DialogTitle>
          <DialogDescription className="text-neutral-600 font-light">
            Elige la sede de Morea más cercana a ti
          </DialogDescription>
        </DialogHeader>
        <div className="flex flex-col gap-4 py-4">
          {locations.map((location) => (
            <Button
              key={location.id}
              onClick={() => handleCitySelect(location.city)}
              className="bg-neutral-900 hover:bg-neutral-800 text-white py-6 text-lg rounded-sm transition-all duration-300 hover:shadow-lg"
            >
              {location.city}
            </Button>
          ))}
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default CitySelectionModal;
